import React from "react";
import Marty from "marty";
import Hero from "../components/Hero";
import Logo from "../../../../utils/components/Logo";

const pressList = [
    {
        date: "November 17th, 2016",
        title: "eero inc. Releases New Software Making Home WiFi System More Intelligent and More Resilient",
        link: "/public/img/press/downloads/eero TrueMesh_Alexa skills_app Press Release_11.17.pdf"
    },
    {
        date: "May 25th, 2016",
        title: "eero inc. Secures $50M in Growth Funding Led by Menlo Ventures",
        link: "/public/img/press/downloads/eero Momentum Press Release.pdf"
    },
    {
        date: "February 23, 2016",
        title: "eero Introduces the World’s First Home WiFi System",
        link: "/public/img/press/downloads/eero FCS Press Release.pdf"
    }
];

const blogList = [
    {
        thumbUrl: "/public/img/press/cousins_video.png",
        title: "This holiday season, give your home a WiFi makeover",
        link: "https://blog.eero.com/this-holiday-season-give-your-home-a-wifi-makeover-841f3906a571#.o5vqf8vew"
    },
    {
        thumbUrl: "/public/img/press/smartest.jpg",
        title: "The world’s smartest WiFi system just got smarter",
        link: "https://blog.eero.com/the-worlds-smartest-wifi-system-just-got-smarter-73888c4716e4#.qexa102vo"
    },
    {
        thumbUrl: "/public/img/press/range.jpg",
        title: "Save yourself the hassle — why range extenders just don’t work",
        link: "https://blog.eero.com/save-yourself-the-hassle-why-range-extenders-just-dont-work-e778e0e333a3#.3skhuv5gv"
    },
    {
        thumbUrl: "/public/img/press/review.jpg",
        title: "Don’t take our word for it: The best-reviewed WiFi system on the market",
        link: "https://blog.eero.com/dont-take-our-word-for-it-the-best-reviewed-wifi-system-on-the-market-3ec8989c01b2#.v50apbsbk"
    },
    {
        thumbUrl: "/public/img/press/family.jpg",
        title: "Modern Family",
        link: "https://blog.eero.com/modern-family-5ffa4551a1f9#.5i4k239vq"
    },
    {
        thumbUrl: "/public/img/press/safe.jpg",
        title: "How eero keeps your network safe and sound",
        link: "https://blog.eero.com/how-eero-keeps-your-network-safe-and-sound-6fcea89711e7#.py4ccul0f"
    },
    {
        thumbUrl: "/public/img/press/five.jpg",
        title: "5 ways to improve your WiFi",
        link: "https://blog.eero.com/5-ways-to-improve-your-wifi-184734f823fc#.sfhi31cm5"
    },
    {
        thumbUrl: "/public/img/press/build.jpg",
        title: "Help us build (and break) things",
        link: "https://blog.eero.com/help-us-build-and-break-things-52a7ba70a1f6#.le3bjgcpv"
    }
];

const photoList = [
    {
        title: "Product photos",
        sections: [
            {
                thumbUrl: "/public/img/press/product-photos/thumb01.jpg",
                title: "eero (individual)",
                fileUrl: "/public/img/press/downloads/eero product-topdown.jpg.zip"
            },
            {
                thumbUrl: "/public/img/press/product-photos/thumb02.jpg",
                title: "eero WiFi system (3-pack)",
                fileUrl: "/public/img/press/downloads/eero product-topdown-3up.jpg.zip"
            },
            {
                thumbUrl: "/public/img/press/product-photos/thumb03.jpg",
                title: "eero side view",
                fileUrl: "/public/img/press/downloads/eero product-front.jpg.zip"
            }
        ]
    },
    {
        title: "Lifestyle photos",
        sections: [
            {
                thumbUrl: "/public/img/press/lifestyle-photos/thumb01.jpg",
                title: "Bookshelf",
                fileUrl: "/public/img/press/downloads/eero lifestyle - bookshelf.jpg.zip"
            },
            {
                thumbUrl: "/public/img/press/lifestyle-photos/thumb02.jpg",
                title: "Kitchen",
                fileUrl: "/public/img/press/downloads/eero lifestyle - kitchen.jpg.zip"
            },
            {
                thumbUrl: "/public/img/press/lifestyle-photos/thumb03.jpg",
                title: "Garage",
                fileUrl: "/public/img/press/downloads/eero lifestyle - garage.jpg.zip"
            }
        ]
    },
    {
        title: "App photos",
        sections: [
            {
                thumbUrl: "/public/img/press/app-photos/thumb01.jpg",
                title: "Placement tip screen",
                fileUrl: "/public/img/press/downloads/eero placeinrange-screenshot.png.zip"
            },
            {
                thumbUrl: "/public/img/press/app-photos/thumb02.jpg",
                title: "Success screen",
                fileUrl: "/public/img/press/downloads/eero success-screenshot.png.zip"
            },
            {
                thumbUrl: "/public/img/press/app-photos/thumb03.jpg",
                title: "Dashboard screen",
                fileUrl: "/public/img/press/downloads/eero dashboard-screenshot.png.zip"
            }
        ]
    }
];

const videoList = [
    {
        thumbUrl: "/public/img/press/videos/thumb01.jpg",
        title: "B-roll",
        fileUrl: "https://d2vw57jh8139vw.cloudfront.net/large-assets/eero-b-roll.mp4",
    },
    {
        thumbUrl: "/public/img/press/videos/thumb02.jpg",
        title: "Mesh video",
        fileUrl: "https://d2vw57jh8139vw.cloudfront.net/large-assets/motion-graphic.mp4",
    }
];

const founderList = [
    {
        thumbUrl: "/public/img/press/founders/thumb01.jpg",
        bioUrl: "/public/img/press/downloads/Nick-bio.pdf.zip",
        name: "Nick Weaver",
        title: "CEO",
        fileUrl: "/public/img/press/downloads/Nick-headshot.jpg.zip",
        networks: [
            {
                iconClass: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/nsweaver"
            },
            {
                iconClass: "eo-icon-twitter",
                url: "https://twitter.com/nsweaves"
            }
        ]
    },
    {
        thumbUrl: "/public/img/press/founders/thumb02.jpg",
        bioUrl: "/public/img/press/downloads/Amos-bio.pdf.zip",
        name: "Amos Schallich",
        title: "VP of Engineering (Software)",
        fileUrl: "/public/img/press/downloads/Amos-headshot.jpg.zip",
        networks: [
            {
                iconClass: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/schallich"
            }
        ]
    },
    {
        thumbUrl: "/public/img/press/founders/thumb03.jpg",
        bioUrl: "/public/img/press/downloads/Nate-bio.pdf.zip",
        name: "Nate Hardison",
        title: "CTO (Hardware)",
        fileUrl: "/public/img/press/downloads/Nate-headshot.jpg.zip",
        networks: [
            {
                iconClass: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/natehardison"
            }
        ]
    }
];

let Press = React.createClass({
    componentWillMount() {
        if (Marty.isBrowser) {
            document.title = "eero - Press";
        }
    },
    render() {
        return (
            <section className="eo-view press">
                <Hero className="press-hero">
                    <h1>Press</h1>
                    <a href="mailto:press@eero.com" className="eo-btn-outline white hover-blue">Get in touch</a>
                </Hero>

                <div className="eo-padded-wrapper">
                    <section className="grid-10 press-releases eo-info-panel">
                        <h2 className="grid-10">Press Releases</h2>
                        <ul className="release-list grid-10">
                            { pressList.map((item, i)=> {
                                return (
                                  <li key={i} className={["release-list-item"].join(" ")}>
                                      <a className="release-list-item-link" href={item.link} target="_blank">
                                          <p className="release-list-item-date">{item.date}</p>
                                          <p className="release-item-title">{item.title}</p>
                                          <p className="release-read-more">Read more <span className="icon eo-icon-arrow-right"/></p>
                                      </a>
                                  </li>
                                );
                            }) }
                        </ul>
                    </section>
                    <hr className="eo-hr grid-10 hide-s"/>
                    <section className="grid-10 blog eo-info-panel">
                        <h2 className="grid-10">What's new at eero</h2>
                        <ul className="blog-list grid-10">
                            { blogList.map((item, i)=> {
                                return (
                                  <li key={i} className={["blog-list-item"].join(" ")}>
                                      <a className="blog-list-item-link" href={item.link} target="_blank">
                                          <img className="blog-item-thumb eo-img-fluid" src={item.thumbUrl}/>

                                          <p className="blog-item-title">{item.title}</p>

                                          <p className="blog-read-more">Read more <span className="icon eo-icon-arrow-right"/></p>
                                      </a>
                                  </li>
                                );
                            }) }
                        </ul>
                    </section>
                    <hr className="eo-hr grid-10 hide-s"/>
                    <section className="grid-10 eo-section eo-info-panel centered download-kit">
                        <h2 className="eo-info-panel-header grid-10 hide-s">Media assets</h2>
                        <h2 className="eo-info-panel-header grid-10 parent hide-m hide-l hide-xl">Photography</h2>

                        <p className="eo-info-panel-copy grid-10 hide-s">Photography, video, logos, and founders' info available below.</p>
                        <div className="grid-10 hide-s">
                            <a href="/public/img/press/downloads/eero Fact Sheet.pdf.zip" className="eo-btn-outline blue">Fact Sheet</a>
                        </div>
                        <section className="grid-10 photography eo-info-panel">
                            {
                                photoList.map((group, i)=> {
                                    return (
                                        <div key={i} className="photo-group">
                                            <p className="photo-group-title">{group.title}</p>
                                            { group.sections.map((section, i2) => {
                                                return (
                                                    <div key={i2} className="photo-group-item">
                                                        <img className="eo-img-fluid photo-group-thumb" src={section.thumbUrl}/>
                                                        <a href={section.fileUrl} className="photo-group-item-copy" target="_blank">{section.title}<span
                                                            className="icon eo-icon-download"/></a>
                                                    </div>
                                                );
                                            }) }
                                        </div>
                                    );
                                })
                            }
                        </section>
                        <section className="grid-5 grid-s-10 videos eo-info-panel">
                            <p className="photo-group-title hide-s">Videos</p>
                            <h2 className="eo-info-panel-header grid-10 parent hide-m hide-l parent hide-xl">Videos</h2>
                            {
                                videoList.map((video, i)=> {
                                    return (
                                        <div key={i} className="video-item grid-5">
                                            <div className="video-item-youtube-link icon eo-icon-play">
                                                <img className="eo-img-fluid video-item-thumb" src={video.thumbUrl}/>
                                            </div>
                                            <a href={video.fileUrl} className="photo-group-item-copy" target="_blank">{video.title}<span className="icon eo-icon-download"></span></a>
                                        </div>
                                    );
                                })
                            }
                        </section>
                        <section className="grid-5 grid-s-10 logos eo-info-panel">
                            <p className="photo-group-title grid-10 hide-s">Logos</p>
                            <h2 className="eo-info-panel-header grid-10 parent hide-m hide-l hide-xl">Logos</h2>

                            <div className="grid-s-10 grid-5 logo-item-wrapper">
                                <div className="logo-item">
                                    <div className="eo-fluid-fixed-aspect-ratio">
                                        <div className="eo-fluid-fixed-aspect-ratio-content">
                                            <Logo className="logo-img"/>
                                        </div>
                                    </div>
                                </div>
                                <a href="/public/img/press/downloads/eero wordmark_grey.png.zip" className="photo-group-item-copy" target="_blank">eero wordmark<span
                                    className="icon eo-icon-download"/></a>
                            </div>
                            <div className="grid-s-10 grid-5 logo-item-wrapper">
                                <div className="logo-item dark">
                                    <div className="eo-fluid-fixed-aspect-ratio">
                                        <div className="eo-fluid-fixed-aspect-ratio-content">
                                            <Logo className="logo-img"/>
                                        </div>
                                    </div>
                                </div>
                                <a href="/public/img/press/downloads/eero wordmark_white.png.zip" className="photo-group-item-copy" target="_blank">eero wordmark<span
                                    className="icon eo-icon-download"/></a>
                            </div>
                        </section>
                        <section className="grid-10 founders eo-info-panel">
                            <p className="photo-group-title hide-s">Founders</p>
                            <h2 className="eo-info-panel-header grid-10 parent hide-m hide-l hide-xl">Co-founders</h2>

                            {
                                founderList.map((founder, i)=> {
                                    return (
                                        <div key={i} className="founder">
                                            <img className="eo-img-fluid founder-thumb" src={founder.thumbUrl}/>
                                            <p className="founder-name"><strong>{founder.name}</strong></p>
                                            <p className="founder-title"><strong>{founder.title}</strong></p>
                                            <a href={founder.fileUrl} className="photo-group-item-copy founder-link" target="_blank">Headshot<span
                                                className="icon eo-icon-download"/></a>
                                            <a href={founder.bioUrl} className="photo-group-item-copy founder-link" target="_blank">Bio<span
                                                className="icon eo-icon-download"/></a>
                                            {founder.networks.map((network, i2) =>
                                                <a key={i2} target="_blank" className={["icon founder-network", network.iconClass].join(" ")} href={network.url}/>
                                            )}
                                        </div>
                                    );
                                })
                            }
                        </section>
                    </section>
                    <hr className="eo-hr grid-10 hide-s"/>
                    <section className="grid-10 inquiries eo-info-panel hide-s">
                        <h2 className="grid-10">Media inquiries</h2>
                        <p className="">Can't find what you need? Reach out at <a className="eo-link" href="mailto:press@eero.com"><strong>press@eero.com</strong></a>.</p>
                    </section>
                </div>
            </section>
        );
    },
    getInitialState() {
        return {};
    }
});

export default Marty.createContainer(Press, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/press/Handler.js
 **/